export default "__VITE_ASSET__BYdKFTx3__"